export default __webpack_public_path__ + "images/39ce7c5e910c439bada1da7a67aa958f.jpg";